export const colors = {
  HR: 'gray',
};
